import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { Accordion as MTSAccordion } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { newYearFaqData } from '../../config/new-year/faq';
const FAQ: FC = () => <AccordionWrapper>
    <CustomAccordionItemWrapper>
      <MTSAccordion domMounted items={newYearFaqData} variant="privateBanking" size="sm" />
    </CustomAccordionItemWrapper>
  </AccordionWrapper>;
export default FAQ;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.tertiary;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.stroke;
const AccordionWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "AccordionWrapper",
  class: "azlioof",
  propsAsIs: false,
  vars: {
    "azlioof-0": [_exp()],
    "azlioof-1": [_exp2()]
  }
}));
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.secondary;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.primary;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSText;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.secondary;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const CustomAccordionItemWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "CustomAccordionItemWrapper",
  class: "c1kcd1lq",
  propsAsIs: false,
  vars: {
    "c1kcd1lq-0": [_exp3()],
    "c1kcd1lq-1": [_exp5()],
    "c1kcd1lq-2": [_exp6()],
    "c1kcd1lq-3": [_exp1(), "px"],
    "c1kcd1lq-4": [_exp8(), "px"],
    "c1kcd1lq-5": [_exp9()],
    "c1kcd1lq-6": [_exp0()],
    "c1kcd1lq-7": [_exp10()],
    "c1kcd1lq-8": [_exp11(), "px"]
  }
}));

require("./FAQ.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./FAQ.tsx");